import { z } from 'zod';
import CalendarDay from '../../../utils/calendar-day';

export const ExportPerformanceFeeSimulationInput = z.object({
  firmId: z.string().optional(),
  fundName: z.string().optional(),
  tagId: z.string().optional(),
  snapshotDate: z.instanceof(CalendarDay).optional(),
  fundStatus: z.array(z.string()).optional(),
  fullyDeployed: z.boolean().optional(),
  startDate: z.instanceof(CalendarDay).optional(),
  endDate: z.instanceof(CalendarDay).optional(),
  fundId: z.string().optional(),
});
